export enum StatePaymentReservation {
  'DEAL' = 'Deal',
  'PAYMENT_PROCESSING' = 'Pago en proceso',
  'PAYMENT_SUCCESS' = 'Pago realizado',
  'PAYMENT_REJECTED' = 'Pago rechazado',
  'PARTIAL_PAYMENT' = 'Pago parcial realizado',
  'DEFERRED_PAYMENT' = 'Pago diferido'
}
